var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup27(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.558,
    height: 181.893,
    viewBox: "0 0 71.558 181.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-951.201 -1289.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M2031.436,445.3l10.314,4.574a3.342,3.342,0,0,0,2.711,0l10.315-4.574a3.343,3.343,0,0,0,1.988-3.057v-8a3.343,3.343,0,0,0-3.343-3.344h-20.63a3.344,3.344,0,0,0-3.343,3.344v8a3.343,3.343,0,0,0,1.988,3.057",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M2072.985,396.9h-12.037v-9.661a5.106,5.106,0,0,0-1.5-3.609l-5.29-5.29a5.1,5.1,0,0,1,0-7.218l5.565-5.566a5.1,5.1,0,0,0,1.495-3.608V353.18a5.105,5.105,0,0,0-1.495-3.609l-7.977-7.977a5.1,5.1,0,0,1,0-7.217l8-8a5.1,5.1,0,0,0,1.495-3.609V311.4a5.1,5.1,0,0,0-1.495-3.609l-17.23-17.23a5.1,5.1,0,0,0-3.609-1.495h-8.837a5.1,5.1,0,0,0-5.1,5.1V396.9h-11.742a5.9,5.9,0,0,0-5.9,5.9v47.961a5.9,5.9,0,0,0,3.354,5.322l29.881,14.292a5.892,5.892,0,0,0,5.09,0l29.879-14.292a5.9,5.9,0,0,0,3.354-5.322V402.8a5.9,5.9,0,0,0-5.9-5.9m-5.9,50.143-23.98,11.47-23.981-11.47V408.7h47.961Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup27);
export default __webpack_public_path__ + "static/media/Group 27.cfe5124b381f269b89973130f9450ec3.svg";
export { ForwardRef as ReactComponent };